module.exports = __webpack_public_path__ + "img/copyright.bfb47431.jpg";